"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const paperColor = "#f4f4f4";
function mul(a, b) {
    return { x: a.x * b, y: a.y * b };
}
function add(a, b) {
    return { x: a.x + b.x, y: a.y + b.y };
}
/**Resta 2 vectores */
function sub(a, b) {
    return { x: a.x - b.x, y: a.y - b.y };
}
/**Producto punto de dos vectores */
function dot(a, b) {
    return a.x * b.x + a.y * b.y;
}
/**Longitud de un vector */
function len(a) {
    return Math.sqrt(dot(a, a));
}
function min(a, b) {
    return { x: Math.min(a.x, b.x), y: Math.min(a.y, b.y) };
}
function max(a, b) {
    return { x: Math.max(a.x, b.x), y: Math.max(a.y, b.y) };
}
function boxFromPoints(points) {
    return {
        min: points.reduce(min),
        max: points.reduce(max)
    };
}
function boxFromBoxes(boxes) {
    return {
        min: boxes.map(x => x.min).reduce(min),
        max: boxes.map(x => x.max).reduce(max)
    };
}
function signatureWidth(deltaLen) {
    return Math.min(Math.round(0.5 + (15 / (deltaLen + 1))), 4);
}
/**Dibuja una linea de una firma */
function drawStroke2(c, a, b) {
    const delta = sub(a, b);
    const deltaLen = len(delta);
    c.lineCap = "round";
    c.lineWidth = signatureWidth(deltaLen);
    c.beginPath();
    c.moveTo(b.x, b.y);
    c.lineTo(a.x, a.y);
    c.stroke();
}
/**Agrupa un arreglo todos los elementos contiguos que encajen entre si */
function groupByAdjacent(items, isAdjacentGroup) {
    if (items.length == 0)
        return [];
    const ret = [];
    let current = [];
    for (var x of items) {
        if (ret.length == 0 && current.length == 0) {
            current.push(x);
        }
        else {
            const last = current[current.length - 1];
            if (isAdjacentGroup(last, x)) {
                current.push(x);
            }
            else {
                //Agregamos current:
                ret.push(current);
                current = [x];
            }
        }
    }
    ret.push(current);
    return ret;
}
/**Dibuja un trazo de una firma */
function drawStroke(c, stroke) {
    if (stroke.length < 2)
        return;
    //Por cada punto agrupamos los anchos:
    const widths = stroke
        .map((x, i, arr) => {
        const a = arr[i - 1];
        const b = x;
        const delta = a && sub(a, b);
        const deltaLen = a && len(delta);
        const width = a && signatureWidth(deltaLen);
        return { x: x.x, y: x.y, width: width };
    })
        .map((x, i, arr) => i == 0 ? Object.assign({}, x, { width: arr[1].width }) : x);
    //Agrupamos por ancho de linea:
    const groups = groupByAdjacent(widths, (a, b) => a.width == b.width).map(x => ({ width: x[0].width, points: x.map(y => y) }));
    //A cada grupo le pegamos el ultimo punto del grupo anterior:
    const groups2 = groups.map((x, i, arr) => {
        if (i == 0)
            return x;
        else {
            const puntosAnt = arr[i - 1].points;
            const puntoAnt = puntosAnt[puntosAnt.length - 1];
            const nuevosPuntos = [puntoAnt].concat(x.points);
            return Object.assign({}, x, { points: nuevosPuntos });
        }
    });
    //Dibuja los grupos
    for (var st of groups2) {
        c.lineCap = "round";
        c.lineWidth = st.width;
        c.lineJoin = "round";
        c.beginPath();
        const points = st.points;
        c.moveTo(points[0].x, points[0].y);
        for (var i = 1; i < points.length; i++) {
            c.lineTo(points[i].x, points[i].y);
        }
        c.stroke();
    }
}
function drawStrokes(c, strokes, target) {
    if (strokes.length == 0)
        return;
    if (target) {
        //Escalamos la caja para que encaje en target:
        const strokeBox = boxFromBoxes(strokes.map(boxFromPoints));
        const targetSize = sub(target.max, target.min);
        const strokeSize = sub(strokeBox.max, strokeBox.min);
        const scale = Math.min(targetSize.y / strokeSize.y, targetSize.x / strokeSize.x);
        const pretransform = (x) => add(mul(sub(x, strokeBox.min), scale), target.min);
        const preTransformStrokeBox = { min: pretransform(strokeBox.min), max: pretransform(strokeBox.max) };
        const boxCenter = (box) => mul(add(box.min, box.max), 0.5);
        const centerTranslate = sub(boxCenter(target), boxCenter(preTransformStrokeBox));
        const transform = (x) => add(pretransform(x), centerTranslate);
        const newStroke = strokes.map(x => x.map(transform));
        drawStrokes(c, newStroke);
    }
    else {
        for (var s of strokes) {
            drawStroke(c, s);
        }
    }
}
function mouseToVector(source, pageX, pageY) {
    const bounding = source.getBoundingClientRect();
    const boundingMin = { x: bounding.left, y: bounding.top };
    const scroll = { x: window.scrollX, y: window.scrollY };
    const offset = add(boundingMin, scroll);
    const eventPage = { x: pageX, y: pageY };
    return sub(eventPage, offset);
}
class CanvasSignature {
    constructor(canvas, onStroke) {
        this.onResize = () => {
            this.context = this.canvas.getContext("2d");
        };
        this.lastDownPos = null;
        this.currentStroke = [];
        this.isReadOnly = false;
        this.onTouchStart = () => {
            this.touchDown = true;
        };
        this.onTouchEnd = () => {
            this.touchDown = false;
            this.onMouseUp();
        };
        this.onTouchMove = (event) => {
            const down = this.touchDown;
            const dibujando = down && !this.isReadOnly;
            if (dibujando) {
                //prevenir el scroll en el celular, ocasiona problemas con la firma en android y iphone
                event.preventDefault();
            }
            const touch = event.touches[0];
            const pos = mouseToVector(event.srcElement, touch.pageX, touch.pageY);
            this.processMouseMove(down, pos);
        };
        this.onMouseMove = (event) => {
            //Si el mouse esta presionado
            const down = event.buttons == 1;
            const pos = mouseToVector(event.srcElement, event.pageX, event.pageY);
            this.processMouseMove(down, pos);
        };
        this.onMouseUp = () => {
            if (this.currentStroke.length > 1) {
                this.onStroke(this.currentStroke);
            }
            this.currentStroke = [];
            this.lastDownPos = null;
        };
        this.canvas = canvas;
        this.onStroke = onStroke;
        this.context = canvas.getContext("2d");
        this.addEventListeners();
    }
    addEventListeners() {
        const c = this.canvas;
        c.addEventListener("mouseup", this.onMouseUp);
        c.addEventListener("touchend", this.onTouchEnd);
        c.addEventListener("touchstart", this.onTouchStart);
        c.addEventListener("mousemove", this.onMouseMove);
        c.addEventListener("touchmove", this.onTouchMove);
    }
    removeEventListeners() {
        const c = this.canvas;
        c.removeEventListener("mouseup", this.onMouseUp);
        c.removeEventListener("touchend", this.onTouchEnd);
        c.removeEventListener("touchstart", this.onTouchStart);
        c.removeEventListener("mousemove", this.onMouseMove);
        c.removeEventListener("touchmove", this.onTouchMove);
    }
    processMouseMove(down, pos) {
        const lastPos = this.lastDownPos;
        if (down && !this.isReadOnly) {
            this.currentStroke.push(pos);
            if (lastPos) {
                drawStroke2(this.context, pos, lastPos);
            }
            this.lastDownPos = pos;
        }
        else {
            this.lastDownPos = null;
        }
    }
}
/**Elemento editor de una firma */
class SignatureCanvas extends React.Component {
    constructor() {
        super(...arguments);
        this.handleCanvas = (canvas) => {
            if (canvas == null) {
                this.canvas = undefined;
                this.drawer.removeEventListeners();
                window.removeEventListener("resize", this.onResize);
            }
            else {
                this.canvas = canvas;
                this.setCanvasSize();
                this.drawer = new CanvasSignature(canvas, this.handleStroke);
                this.refresh(this.props);
                window.addEventListener("resize", this.onResize);
                this.onResize();
            }
        };
        this.onResize = () => {
            const doResize = () => {
                if (this.setCanvasSize()) {
                    this.drawer.onResize();
                }
            };
            const times = [10, 50, 100, 200];
            doResize();
            for (var time of times) {
                setTimeout(doResize, time);
            }
        };
        this.handleStroke = (stroke) => {
            if (this.props.onChange) {
                this.props.onChange(this.props.value.concat([stroke]));
                this.refresh(this.props);
            }
        };
    }
    componentWillUnmount() {
        window.removeEventListener("resize", this.onResize);
    }
    componentWillReceiveProps(props) {
        this.refresh(props);
    }
    /**Dibuja los strokes */
    refresh(props) {
        const strokes = props.value;
        if (!this.canvas)
            return;
        if (this.drawer)
            this.drawer.isReadOnly = props.onChange == null;
        //Limpia el canvas
        const context = this.canvas.getContext("2d");
        context.clearRect(0, 0, this.canvas.width, this.canvas.height);
        //Dibujamos los strokes:
        const margin = 10;
        const targetBox = { min: { x: margin, y: margin }, max: { x: this.canvas.width - margin * 2, y: this.canvas.height - margin * 2 } };
        drawStrokes(context, strokes, this.props.zoomToFit ? targetBox : undefined);
    }
    setCanvasSize() {
        if (this.canvas) {
            const newWidth = this.canvas.offsetWidth;
            const newHeight = this.canvas.offsetHeight;
            if (this.canvas.width != newWidth || this.canvas.height != newHeight) {
                this.canvas.width = newWidth;
                this.canvas.height = newHeight;
                this.refresh(this.props);
                return true;
            }
        }
        return false;
    }
    render() {
        return (React.createElement("canvas", { ref: this.handleCanvas, style: {
                background: paperColor,
                width: "100%",
                height: "100%"
            } }));
    }
}
exports.SignatureCanvas = SignatureCanvas;



//////////////////
// WEBPACK FOOTER
// ./~/kea-react/dist/signatureCanvas.js
// module id = 2256
// module chunks = 0